var map = {
	"./Big Hit To Head (1).fbx": "3116",
	"./Big Hit To Head (2).fbx": "d5b6",
	"./Big Hit To Head.fbx": "d33d",
	"./Big Kidney Hit.fbx": "407c",
	"./Big Rib Hit.fbx": "70b6",
	"./Big Side Hit.fbx": "0fc7",
	"./Big Stomach Hit.fbx": "0d0b",
	"./Center Block (1).fbx": "c582",
	"./Center Block.fbx": "a852",
	"./Head Hit (1).fbx": "abeb",
	"./Head Hit (2).fbx": "5945",
	"./Head Hit (3).fbx": "806a",
	"./Head Hit (4).fbx": "1196",
	"./Head Hit (5).fbx": "a2ee",
	"./Head Hit (6).fbx": "1724",
	"./Head Hit (7).fbx": "d0d6",
	"./Head Hit (8).fbx": "1a5e",
	"./Head Hit.fbx": "9f46",
	"./Hit Reaction.fbx": "aa97",
	"./Hit To Body (1).fbx": "f3bc",
	"./Hit To Body (2).fbx": "d970",
	"./Hit To Body (3).fbx": "3e64",
	"./Hit To Body (4).fbx": "030c",
	"./Hit To Body.fbx": "7012",
	"./Kidney Hit.fbx": "cf53",
	"./Left Block (1).fbx": "9c35",
	"./Left Block.fbx": "430c",
	"./Light Hit To Head (1).fbx": "4802",
	"./Light Hit To Head (2).fbx": "5b5c",
	"./Light Hit To Head.fbx": "837d",
	"./Medium Hit To Head (1).fbx": "f6e7",
	"./Medium Hit To Head (2).fbx": "b77a",
	"./Medium Hit To Head.fbx": "efdd",
	"./Receive Punch To The Face.fbx": "0402",
	"./Receive Stomach Uppercut.fbx": "f791",
	"./Receive Uppercut To The Face.fbx": "2f9c",
	"./Receiving A Big Uppercut.fbx": "11cf",
	"./Receiving An Uppercut.fbx": "bb10",
	"./Rib Hit.fbx": "b0ec",
	"./Right Block (1).fbx": "0f1c",
	"./Right Block.fbx": "d7e7",
	"./Side Hit.fbx": "06c6",
	"./Stomach Hit.fbx": "cda8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "46db";